import React, { useState } from "react";
import { FiEye, FiEyeOff, FiX } from "react-icons/fi";
import api, { apiError } from "../../lib/api";
import RenderToast from "../../appcomponents/RenderToast";
import styles from "./ChangePassword.module.css";

export default function ChangePasswordModal({ open, onClose, onSuccess }) {
  const [form, setForm] = useState({
    old_password: "",
    new_password: "",
    confirm_password: "",
  });
  const [show, setShow] = useState({ old: false, next: false, confirm: false });
  const [saving, setSaving] = useState(false);

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.old_password || !form.new_password || !form.confirm_password) {
      RenderToast({ type: "error", message: "All password fields are required." });
      return;
    }
    if (form.new_password !== form.confirm_password) {
      RenderToast({ type: "error", message: "New password and confirm password must match." });
      return;
    }

    setSaving(true);
    try {
      const response = await api.post("/api/profile.php", {
        action: "change_password",
        old_password: form.old_password,
        new_password: form.new_password,
      });
      if (!response.data?.success) {
        throw new Error(response.data?.message || "Unable to update password.");
      }
      RenderToast({ type: "success", message: "Password updated successfully." });
      setForm({ old_password: "", new_password: "", confirm_password: "" });
      onSuccess?.();
      onClose?.();
    } catch (err) {
      RenderToast({ type: "error", message: apiError(err) });
    } finally {
      setSaving(false);
    }
  };

  const inputType = (field) => (show[field] ? "text" : "password");

  return (
    <div className={styles.backdrop} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h3>Change Password</h3>
          <button type="button" className={styles.closeBtn} onClick={onClose}>
            <FiX />
          </button>
        </div>
        <form className={styles.form} onSubmit={handleSubmit}>
          <label>
            <span>Current Password</span>
            <div className={styles.passwordField}>
              <input
                type={inputType("old")}
                value={form.old_password}
                onChange={(e) => setForm((prev) => ({ ...prev, old_password: e.target.value }))}
              />
              <button
                type="button"
                className={styles.eyeBtn}
                onClick={() => setShow((prev) => ({ ...prev, old: !prev.old }))}
              >
                {show.old ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>
          </label>
          <label>
            <span>New Password</span>
            <div className={styles.passwordField}>
              <input
                type={inputType("next")}
                value={form.new_password}
                onChange={(e) => setForm((prev) => ({ ...prev, new_password: e.target.value }))}
              />
              <button
                type="button"
                className={styles.eyeBtn}
                onClick={() => setShow((prev) => ({ ...prev, next: !prev.next }))}
              >
                {show.next ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>
          </label>
          <label>
            <span>Confirm Password</span>
            <div className={styles.passwordField}>
              <input
                type={inputType("confirm")}
                value={form.confirm_password}
                onChange={(e) => setForm((prev) => ({ ...prev, confirm_password: e.target.value }))}
              />
              <button
                type="button"
                className={styles.eyeBtn}
                onClick={() => setShow((prev) => ({ ...prev, confirm: !prev.confirm }))}
              >
                {show.confirm ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>
          </label>
          <div className={styles.actions}>
            <button type="button" className={styles.secondaryBtn} onClick={onClose} disabled={saving}>
              Cancel
            </button>
            <button type="submit" className={styles.primaryBtn} disabled={saving}>
              {saving ? "Updating..." : "Update Password"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
